// @ts-nocheck
/* eslint-disable */
export default class MyMapsLazyLoad {
	constructor(opts) {
		this._opts = Object.assign({
			perc: 85, // u kolika % volat callback?
			cb: null, // callback funkce
			scrollTimeout: 50, // timeout pro scroll, nechcmeme volat x eventu
			testSelector: "", // testovaci selector, jestli scroll event nastal uvnitr urciteho elementu
			container: null, // container, do ktereho se budou pridavat polozky, testujeme na nem jeho vysku
			scrollEl: Mapy.getComponent("layout").getScrollNode() // scroll element
		}, opts);

		this._toID = null;
		this._enabled = null;
		this._lastTarget = null;
		this._container = this._opts.container;
		this._cacheContHeight = 0;

		this.enabled = true;
	}

	/**
	 * Nastaveni containeru pro test vysky.
	 *
	 * @param  {Element} cont
	 */
	set container(cont) {
		this._container = cont;
	}

	/**
	 * Zapnuti/vypnuti scrollu.
	 *
	 * @param  {Boolean} state Novy stav
	 */
	set enabled(state) {
		this._cacheContHeight = 0;
		if (this._enabled == state) { return; }
		this._enabled = state;

		if (this._enabled) {
			if (this._opts.testSelector) {
				this._opts.scrollEl.addEventListener("pointermove", this);
			}
			this._opts.scrollEl.addEventListener("scroll", this);
			document.addEventListener("scroll", this);
		}
		else {
			if (this._opts.testSelector) {
				this._opts.scrollEl.removeEventListener("pointermove", this);
			}
			this._opts.scrollEl.removeEventListener("scroll", this);
			document.removeEventListener("scroll", this);
		}
	}

	/**
	 * Ziskani stavu.
	 *
	 * @return {Boolean}
	 */
	get enabled() {
		return this._enabled;
	}

	handleEvent(e) {
		if (e.type == "pointermove") {
			this._lastTarget = e.target;
		}
		else if (e.type == "scroll" && this._container) {
			if (this._opts.testSelector && this._lastTarget) {
				let testContainer = this._opts.scrollEl.querySelector(this._opts.testSelector);
				let el = this._lastTarget.closest(this._opts.testSelector) || this._lastTarget == this._opts.scrollEl.querySelector(this._opts.testSelector) || this._lastTarget == this._opts.scrollEl;

				if (!el) {
					return;
				}
			}

			if (this._toID) {
				clearTimeout(this._toID);
				this._toID = null;
			}

			this._toID = setTimeout(() => {
				this._scroll();
			}, this._opts.scrollTimeout);
		}
	}

	/**
	 * Vlastni scroll event.
	 */
	_scroll() {
		let scrollTop;

		if (Mapy.Util.isSmallResolution()) {
			scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
		}
		else {
			scrollTop = this._opts.scrollEl.scrollTop;
		}

		let windowHeight = window.innerHeight;
		let contHeight = this._container.offsetHeight;
		let currentPerc = Math.max(Math.min(Math.round(100 * (scrollTop + windowHeight) / contHeight), 100), 0);

		if (currentPerc > this._opts.perc) {
			// na tuhle vysku jsme jiz vyslali callback
			if (this._cacheContHeight == contHeight) return;

			// kes aktualni vysky
			this._cacheContHeight = contHeight;

			// callback
			if (typeof this._opts.cb === "function") {
				this._opts.cb();
			}
		}
	}
}
